import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { get } from 'lodash';

import ApplicationId from '../../components/ApplicationId';
import Header from '../../components/Header';
import imgPending from '../../assets/images/pending.svg';

const Pending = ({ navigate, checkinData, params, searchParams }) => {
  const workflowType = get(params, 'workflowType');
  const key = searchParams.get('key');

  useEffect(() => {
    if (get(checkinData, ['data', 'data']) === undefined) {
      navigate(`${workflowType ? `/${workflowType}` : ''}/?key=${key}`);
    }
  }, []);

  return (
    <div className="transition-item wrapper v-center">
      <Header />
      <ApplicationId id={get(checkinData, 'attributes.entityId')} style={{ marginTop: 10 }} />
      <div className="content appIdVisible">
        <img src={imgPending} alt="" />
        <h1>APPLICATION PENDING</h1>
        <p>You are pre-approved, but we need a bit more information before we can move forward. One of our credit specialists will review your application and contact you by phone and/or email within 24 hours regarding your application.</p>
      </div>
      <div className="footer">
        <div className="row">
          <div className="col">
            <a href="tel:+18009946177" className="btn btn-primary">Contact Us</a>
          </div>
        </div>
      </div>
    </div>
  );
};

Pending.propTypes = {
  navigate: PropTypes.func.isRequired,
  checkinData: PropTypes.object.isRequired,
  params: PropTypes.object.isRequired,
  searchParams: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  checkinData: state.screen.checkinData,
});

export default connect(mapStateToProps)(Pending);
